import { render } from "./StructureSkeleton.vue?vue&type=template&id=3fe16918&scoped=true&ts=true"
import script from "./StructureSkeleton.vue?vue&type=script&lang=ts"
export * from "./StructureSkeleton.vue?vue&type=script&lang=ts"

import "./StructureSkeleton.vue?vue&type=style&index=0&id=3fe16918&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe16918"]])

export default __exports__